import React from "react";

const backend = [
    {
        name: 'Webflow',
    },
    {
        name: 'Shopify',
    },
    {
        name: 'Photographer',
    },
    {
        name: 'SMM',
    },
    {
        name: 'Video Editor',
    }

]

const Other = () => {
    return (
        <div className='skills__content'>
            <h3 className='skills__title'>Other</h3>

            <div className="skills__box">
                {backend.map((item, index) => (
                    <div className="skills__data" key={index}>
                        <i className='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">
                                {item.name}
                            </h3>
                            <span className="skills__level">
                                {item.level}
                            </span>
                        </div>
                    </div>

                ))}
            </div>
        </div>
    )
}

export default Other;
